<template>
  <div class="bht-header">
    <div class="bht-header-fixed" :class="classname">
      <div class="bht-header-content">
        <img
            class="bht-header-logo"
            src="/picture/logo.png"
            alt="logo"
        />
        <!-- <div class="bht-header-name">{{ webInfo.webName }}</div> -->

        <div class="bht-header-nav">
          <div
            class="nav-item"
            :class="{
              actived: (isIndex && item.title === '首页') || item.url === pathname,
            }"
            v-for="(item, index) in webInfo.webDhlj"
            :key="index"
            @click.prevent.stop="tabClick(item)"
          >
            <span class="nav-title">{{ item.title }}</span>

            <!-- <div class="child-cntent" v-if="item.clild && item.clild.length > 0">
              <span
                v-for="(cItem, cIndex) in item.clild"
                :key="cIndex"
                @click.prevent.stop="tabClick(cItem)"
              >
                {{ cItem.title }}
              </span>
            </div> -->
          </div>
        </div>

        <div class="bht-header-contact">
          <div class="tel">
            <i class="iconfont">&#xebd3;</i>
            <div>
              <div>{{ webInfo.phone1 }}</div>
              <div v-if="webInfo.phone2">
                {{ webInfo.phone2 }}
              </div>
            </div>
          </div>
        </div>

        <div class="swiperBtn" v-if="!loginStatus">
          <el-button type="primary" size="medium" @click="handleLogin()">登录</el-button>
          <el-button plain @click="handleLogin('register')" size="medium">注册</el-button>
        </div>
        <div class="swiperBtn" v-if="loginStatus">
          <i
            class="el-icon-user-solid"
            style="color: white; font-size: 26px; margin-right: 5px"
          ></i>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <span class="loginBtn"
                >{{ getUserinfo.loginUser.loginname
                }}<i class="el-icon-arrow-down el-icon--right"></i
              ></span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="userinfo">账号信息</el-dropdown-item>
              <el-dropdown-item command="out">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <el-backtop :bottom="100">
        <i class="el-icon-arrow-up"></i>
      </el-backtop>
      <mylogin ref="login" @confirm="loginConfirm"></mylogin>
      <myaccount ref="account" v-if="open" @cancle="handleCancel"></myaccount>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import mylogin from "~/pages/branch/yfh/login/index";
import myaccount from "~/pages/branch/yfh/order/account.vue";
export default {
  inject: ["webInfo"],
  components: {
    mylogin,
    myaccount,
  },
  data: function () {
    return {
      classname: "home",
      open: false,
    };
  },
  computed: {
    pathname() {
      return this.$route.path;
    },
    isIndex() {
      let navList = this.webInfo.webDhlj,
        homeItem = navList[0];

      return ["/", "/index.html", homeItem.url].includes(this.$route.path);
    },
    ...mapGetters({
      getUserinfo: "userinfo/getUserinfo",
      loginStatus: "userinfo/loginStatus",
    }),
  },
  methods: {
    // 监听下拉滚动
    handleScroll() {
      var that = this;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (that.activeIndex == "index") {
        //首页
        if (scrollTop > 320) {
          this.classname = "homeOther";
        } else {
          this.classname = "home";
        }
      } else {
        //其他页面
        if (scrollTop > 450) {
          this.classname = "homeOther";
        } else {
          this.classname = "home";
        }
      }
    },
    tabClick: function (item) {
      if (item.title === "产品介绍") {
        if (!this.isIndex) {
          let navList = this.webInfo.webDhlj,
            homeItem = navList[0];

          this.goto({
            path: `${homeItem.url}${item.url}`,
          });
        } else {
          let guaranteEnquiryEL = document.getElementById("productServices");

          if (guaranteEnquiryEL && guaranteEnquiryEL.offsetTop) {
            if (window.ActiveXObject || "ActiveXObject" in window) {
              document.documentElement.scrollTop = guaranteEnquiryEL.offsetTop - 70;
            } else {
              window.scrollTo({
                top: guaranteEnquiryEL.offsetTop - 70,
                behavior: "smooth",
              });
            }
          }
        }

        return;
      }

      if (!item.url) return;

      if (item.clild) return;

      if (item.title === "首页") {
        this.goto("/");
        // this.$router.push({
        //   path: "/",
        // });
      } else {
        if (item.target === "_self") {
          // window.location.href = item.url;

          this.goto(item.url);
          // this.$router.push({
          //   path: item.url,
          // });
        } else {
          window.open(item.url, item.target);
        }
      }
    },
    handleLogin(e) {
      this.$refs.login.handleOpen("", e);
    },
    handleCancel() {
      this.open = false;
    },
    handleCommand(e) {
      if (e == "out") {
        //退出登录
        this.handleRevoke();
      } else if (e == "userinfo") {
        //账号信息
        this.handleAccount();
      }
    },
    //退出登录
    handleRevoke() {
      this.$store.dispatch("userinfo/logout", () => {
        showMsg("退出成功", "success");
        window.sessionStorage.clear();
        this.goto("/");
      });
    },
    //账号信息
    handleAccount() {
      this.open = true;
    },
    loginConfirm() {
      console.log("loginConfirm");
    },
  },
  mounted: function () {
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.home {
  background-color: rgba(11, 62, 217, 1);
  color: #333;
}

.homeOther {
  background-color: rgba(11, 62, 217, 0.8);
  color: #333;
}
.bht-header {
  height: 90px;

  .bht-header-fixed {
    position: fixed;
    width: 100%;
    min-width: 1200px;
    height: 90px;
    z-index: 999;
    // background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.bht-header-content {
  width: 1350px;
  display: flex;
  align-items: center;

  .bht-header-logo {
    flex-shrink: 0;
    width: 240px;
  }
  .bht-header-name {
    font-size: 30px;
    font-weight: bold;
    color: white;
    width: 250px;
  }

  .bht-header-nav {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    .nav-item {
      display: block;
      cursor: pointer;
      font-size: 18px;
      margin-right: 20px;
      transition: all 0.3s;
      position: relative;
      color: white;
      border-radius: 5px;
      padding: 4px 12px;
      &:hover {
        // font-weight: 700;
        // color: rgba(69, 108, 226, 0.5);
      }

      &.actived {
        background-color: #456ce2;
      }
    }
  }

  .bht-header-contact {
    flex-shrink: 0;
    font-size: 16px;
    color: white;

    .tel,
    .email {
      display: flex;
      align-items: center;
      font-size: 20px;
    }

    .iconfont {
      font-size: 22px;
      margin-right: 10px;
      flex-shrink: 0;
    }
  }

  .swiperBtn {
    // margin-left: 30px;
    width: 180px;
    display: flex;
    align-items: center;
    justify-content: right;
    flex: 0.3;
  }
  .swiperBtn .el-button--primary {
    color: rgba(255, 255, 255, 1);
    border-color: rgba(255, 255, 255, 1);
    background-color: rgba(255, 255, 266, 0);
  }
  .swiperBtn .el-button--primary:hover {
    color: rgba(255, 255, 255, 0.8);
    border-color: rgba(255, 255, 255, 0.8);
    background-color: rgba(255, 255, 266, 0.1);
  }
  .swiperBtn .el-button--primary:active {
    color: rgba(255, 255, 255, 1);
    border-color: rgba(255, 255, 255, 1);
    background-color: rgba(255, 255, 266, 0);
  }
}

.loginBtn {
  color: white;
  font-size: 18px;
  line-height: 40px;
}

@media screen and (max-width: 1200px) {
  .bht-header-content .bht-header-nav .nav-item {
    margin-right: 6px;
  }
}
</style>
